import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { FaBars } from 'react-icons/fa';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="navbar">
      <div>
        <img
          className="icon"
          src="imgs/estga_redes sociais_branco.png"
          alt="ESTGA logo"
        />
      </div>
      <div className="logo">
        <a href="https://www.ua.pt/estga">
          <img src="imgs/estga_pt_horizontal_branco.png" alt="ESTGA logo" />
        </a>
      </div>
      <div>
        <a href="https://miup.web.ua.pt/">
          <img src="imgs/MIUP25_logo_white.png" alt="ESTGA-25 logo" className="icon" />
        </a>
      </div>
      <div>
        <a href="https://miup.web.ua.pt/2024">
          <img src="imgs/LogoMIUP2024.png" alt="ESTGA-24 logo" className="icon" />
        </a>
      </div>
      <div className="logo">
        <a href="https://miup.web.ua.pt/">
          <img src="imgs/MIUP25_logo_white.png" alt="MIUP-25 logo" />
        </a>
      </div>
      <div className="logo">
        <a href="https://miup.web.ua.pt/2024">
          <img src="imgs/LogoMIUP2024.png" alt="MIUP-24 logo" />
        </a>
      </div>
      <nav>
        <button className="dropdown-toggle" onClick={toggleDropdown}>
          <FaBars size={24} color="white" />
        </button>
        <ul className={`dropdown-menu ${isOpen ? "open" : ""}`}>
          <li>
            <Link
              to="about"
              onClick={toggleDropdown}
              smooth={true}
              duration={500}
            >
              Sobre
            </Link>
          </li>
          <li>
            <Link
              to="program"
              onClick={toggleDropdown}
              smooth={true}
              duration={500}
            >
              Programa
            </Link>
          </li>
          <li>
            <Link
              to="regulation"
              onClick={toggleDropdown}
              smooth={true}
              duration={500}
            >
              Regulamento
            </Link>
          </li>
          <li>
            <Link
              to="organization"
              onClick={toggleDropdown}
              smooth={true}
              duration={500}
            >
              Organização
            </Link>
          </li>
          <li>
            <Link
              to="location"
              onClick={toggleDropdown}
              smooth={true}
              duration={500}
            >
              Localização
            </Link>
          </li>
          {/*}   <li>
              <Link
                to="gallery"
                onClick={toggleDropdown}
                smooth={true}
                duration={500}
              >
                Imagens
              </Link>
            </li>
            <li>
              <Link
                to="problemset"
                onClick={toggleDropdown}
                smooth={true}
                duration={500}
              >
                Problemas
              </Link>
            </li>*/}
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;